import { SuggestionMetadata } from '../../../chat.types';
import { MessageHandler, MessageVariant } from '../../ChatUserMessage.types';

export const suggestionMessageHandler: MessageHandler<SuggestionMetadata> = {
  submit: (args) => ({
    role: 'user' as const,
    parts: [{ type: 'text', text: args.text || '' }],
    metadata: { type: MessageVariant.SUGGESTION },
  }),
};
